import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown, FaCog, FaSignOutAlt } from "react-icons/fa";
import "../css/main/Breadcrumbs.css";
import "../css/others/Table.css";
import { apiCall } from "./ApiCall";
import { BreadcrumbsProps } from '../interFaces/interfaces';
import EncryptionUtils from "./encryptionUtils";
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ handleLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter(Boolean);
  const decodedPathnames = pathnames.map(decodeURIComponent);
  const clientId = localStorage.getItem("clientId");
  const [showDropdown, setShowDropdown] = useState(false);
  const [userInfo, setUserInfo] = useState<any>({});
  const dropdownRef = useRef<HTMLDivElement>(null);
  const userEmail = localStorage.getItem("email");
  const { roleName, roleId, campaignName, functionCampaignName } = EncryptionUtils.getAuthInfo();
  const handleProfileClick = () => {
    setShowDropdown(!showDropdown);
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowDropdown(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        if (!userEmail) return;
        const response = await apiCall("get", `/api/users/user/role?email=${userEmail}&roleId=${roleId}&clientId=${clientId}`);
        if (response) {
          const { firstName, lastName, email } = response;
          EncryptionUtils.set("userInfo", response);
          EncryptionUtils.set("firstName", firstName || "");
          EncryptionUtils.set("lastName", lastName || "");
          setUserInfo({ firstName, lastName, email, roleName: roleName || ""});
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };
    fetchUserInfo();
  }, [userEmail, roleId, roleName, clientId]);
  const breadcrumbConfig: { [key: string]: any[] } = {
    dashboard: [["/dashboard", "Dashboard"]],
    project: [["/dashboard", "Dashboard"], [null, "Projects"]],
    projectdetails: [["/dashboard", "Dashboard"], ["/project", "Projects"], [null, `Project Details - ${decodedPathnames[1]?.toUpperCase()}`]],
    campaigns: [["/dashboard", "Dashboard"], [null, "Campaigns"]],
    createcampaign: [["/dashboard", "Dashboard"], ["/campaigns", "Campaigns"], [null, "Create Campaign"]],
    campaigndetails: [["/dashboard", "Dashboard"], ["/campaigns", "Campaigns"], [null, `Campaign Name : ${campaignName?.toUpperCase()}`]],
    addproject: [["/dashboard", "Dashboard"], ["/campaigns", "Campaigns"], [() => navigate(-1), `Campaign Name : ${campaignName?.toUpperCase()}`], [null, "Add Project"]],
    campaignprojecthistory: [["/dashboard", "Dashboard"], [() => navigate(-1), `Campaigns`], [null, `Campaign Project History`]],
    campaignprojecthistorydetails: [["/dashboard", "Dashboard"], ["/campaigns", `Campaigns`], [() => navigate(-1), `Campaign Project History`], [null, `Campaign Project History Details`]],
    campaignDetailsInfo: [["/dashboard", "Dashboard"], ["/campaigns", "Campaigns"], [() => navigate(-1), `Campaign Name : ${campaignName?.toUpperCase()}`], [null, `Project Details - ${decodedPathnames[1]?.toUpperCase()}`]],
    functioncampaigns: [["/dashboard", "Dashboard"], [null, "Function Campaigns"]],
    functioncampaigndetails: [["/dashboard", "Dashboard"], ["/functioncampaigns", "Function Campaigns"], [null, `Function Campaign Name : ${functionCampaignName?.toUpperCase()}`]],
    functionCampaigndetailsinfo: [["/dashboard", "Dashboard"], ["/functioncampaigns", "Function Campaigns"], [() => navigate(-1), `Function Campaign Name : ${functionCampaignName?.toUpperCase()}`], [null, `Function Details Information - ${decodedPathnames[1]?.toUpperCase()}`]],
    filters: [["/dashboard", "Dashboard"], ["/campaigns", "Campaigns"], [() => navigate(-1), `Campaign Name : ${campaignName?.toUpperCase()}`], [null, "Filters"]],
    rolemapping: [["/dashboard", "Dashboard"], [null, "Role Mapping"]],
    initialsetup: [["/dashboard", "Dashboard"], [null, "Field Mapping"]],
    buildformula: [["/dashboard", "Dashboard"], [null, "Build Formula"]],
    bulkupload: [["/dashboard", "Dashboard"], [null, "Project Data Upload"]],
    bulkuploaddetails: [["/dashboard", "Dashboard"], ["/bulkupload", "Project Data Upload"], [null, `Project Data Upload Details`]],
    mappedheaders: [["/dashboard", "Dashboard"], ["/bulkupload", "Project Data Upload"], [null, "Mapped Headers"]],
    usermanagement: [["/dashboard", "Dashboard"], [null, "User Management"]],
    adminchecklists: [["/dashboard", "Dashboard"], [null, "Checklists"]],
    adminchecklistdetails: [["/dashboard", "Dashboard"], ["/adminchecklists", "Checklists"], [null, `Checklist Details`]],
    globaltemplates: [["/dashboard", "Dashboard"], ["/adminchecklists", "Checklists"], [null, "Global Checklists"]],
    globaltemplatesdetails: [["/dashboard", "Dashboard"], ["/adminchecklists", "Checklists"], ["/globaltemplates", "Global Checklists"], [null, "Global Checklist Details"]],
    adminviewchecklistdetails: [["/dashboard", "Dashboard"], ["/adminchecklists", "Checklists"], [null, `Checklist Details`]],
    auditorchecklists: [["/dashboard", "Dashboard"], [null, "Audit"]],
    auditorchecklistdetails: [["/dashboard", "Dashboard"], ["/auditorchecklists", "Audit"], [null, `Audit Details`]],
    auditorviewchecklistdetails: [["/dashboard", "Dashboard"], ["/auditorchecklists", "Audit"], [null, `View Audit Details`]],
    profilepage: [["/dashboard", "Dashboard"], [null, "ProfilePage"]],
    customizetheme: [["/dashboard", "Dashboard"], [null, "Customize Theme"]],
    templates: [["/dashboard", "Dashboard"], [null, `Email Template`]],
    createtemplate: [["/dashboard", "Dashboard"], ["/templates", `Email Template`], [null, `Create New Email Template`]],
    emailtemplatedetail: [["/dashboard", "Dashboard"], ["/templates", `Email Template`], [null, `Email Template Details`]],
    nctracker: [["/dashboard", "Dashboard"], [null, `NC Tracker`]],
    nctrackerdetails: [["/dashboard", "Dashboard"], ["/nctracker", `NC Tracker`], [null, `NC Tracker - ${decodedPathnames[1]?.toUpperCase()}`]],
    functions: [["/dashboard", "Dashboard"], [null, `Functions`]],
    createfunction: [["/dashboard", "Dashboard"], ["/functions", `Functions`], [null, `Create Functions`]],
    addfunction: [["/dashboard", "Dashboard"], ["/functions", `Functions`], [null, `Add Functions`]],
    createfunctionCampaign: [["/dashboard", "Dashboard"], ["/functioncampaigns", "Function Campaigns"], [null, `Create Function Campaign`]],
    addcampaignfunction: [["/dashboard", "Dashboard"], ["/functioncampaigns", "Function Campaigns"], [() => navigate(-1), `Function Campaign Name : ${functionCampaignName?.toUpperCase()}`], [null, `Add Functions`]],
    functionchecklist: [["/dashboard", "Dashboard"], [null, `Function Checklist`]],
    functionchecklistdetails: [["/dashboard", "Dashboard"], ["/functionchecklist", `Function Checklist`], [null, `Function ChecklistDetails`]],
    functionviewchecklistdetails: [["/dashboard", "Dashboard"], ["/functionchecklist", `Function Checklist`], [null, `Function ChecklistDetails`]],
    globalfunction: [["/dashboard", "Dashboard"], ["/functionchecklist", `Function Checklists`], [null, `Global Function Checklists`]],
    globalfunctiondetails: [["/dashboard", "Dashboard"], ["/functionchecklist", `Function Checklists`], [() => navigate(-1), `Global Function Checklists`], [null, `Global Function Checklists Details`]],
    auditorfunctionchecklists: [["/dashboard", "Dashboard"], [null, `Function Audit`]],
    auditorfunctionchecklistdetails: [["/dashboard", "Dashboard"], ["/auditorfunctionchecklists", `Function Audit`], [null, `Function Audit Details`]],
    auditorviewfuntionchecklistdetails: [["/dashboard", "Dashboard"], ["/auditorfunctionchecklists", `Function Audit`], [null, `Function Audit Details`]],
    functionnctracker: [["/dashboard", "Dashboard"], [null, `Function NC Tracker`]],
    functionnctrackerdetails: [["/dashboard", "Dashboard"], ["/functionnctracker", `Function NC Tracker`], [null, `Function NC Tracker Details`]],
    meetingtracker: [["/dashboard", "Dashboard"], [null, `Meeting Tracker`]],
    meetingtrackerdetails: [["/dashboard", "Dashboard"], ["/meetingtracker", `Meeting Tracker`], [null, `Meeting Tracker Details`]],
    meetingtrackerdetailsinfo: [["/dashboard", "Dashboard"], ["/meetingtracker", "Meeting Tracker"], [() => navigate(-1), "Meeting Tracker Details"], [null, "Meeting Tracker Project Details"]],
    functionmeetingtracker: [["/dashboard", "Dashboard"], [null, `Function Meeting Tracker`]],
    functionmeetingtrackerdetails: [["/dashboard", "Dashboard"], ["/functionmeetingtracker", `Function Meeting Tracker`], [null, `Function Meeting Tracker Details`]],
    functionmeetingtrackerdetailsinfo: [["/dashboard", "Dashboard"], ["/functionmeetingtracker", "Function Meeting Tracker"], [() => navigate(-1), "Function Meeting Tracker Details"], [null, "Function Meeting Tracker Function Details"]],
    excludedprojectdetails: [["/dashboard", "Dashboard"], [() => navigate(-1), "Excluded Campaign Project"]],
    excludedcampaignprojectdetails: [["/dashboard", "Dashboard"], [() => navigate(-1), "Excluded Campaign Project"], [() => navigate(-1), "Excluded Project Details Information"]]
  };
  const renderBreadcrumb = (link: string | null | (() => void), label: string, index: number) => {
    if (typeof link === "function") {
      return (
        <li key={index} className="breadcrumb-item">
          <span className="breadcrumb-link" onClick={link} >{label}</span>
        </li>
      );
    }
    return link ? (
      <li key={index} className="breadcrumb-item">
        <Link to={link} className="breadcrumb-link">{label}</Link>
      </li>
    ) : (
      <li key={index} className="breadcrumb-item active" aria-current="page">{label}</li>
    );
  };
  const breadcrumbs = breadcrumbConfig[pathnames[0]] || [["/dashboard", "Dashboard"]];
  const handleCustomizeThemeClick = () => {
    navigate("/customizetheme");
    setShowDropdown(false);
  };
  return (
    <nav aria-label="breadcrumb" className="breadcrumb-container">
      <ol className="breadcrumb">
        {breadcrumbs.map(([link, label], index) => renderBreadcrumb(link, label, index))}
      </ol>
      {userInfo && (
        <div className="profile-topbar" onClick={handleProfileClick} ref={dropdownRef} onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() => setTimeout(() => { if (!dropdownRef.current?.matches(':hover')) { setShowDropdown(false) } }, 200)}>
          <div className="profile-name-role">
            <span className="profile-name">{`${userInfo.firstName || ""} ${userInfo.lastName || ""}`}</span>
            <span className="profile-role">{userInfo.roleName}</span>
          </div>
          <FaChevronDown className={`dropdown-icon ${showDropdown ? "open" : ""}`} />
          {showDropdown && (
            <div className="profile-dropdown" onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() => setTimeout(() => { if (!dropdownRef.current?.querySelector('.profile-topbar:hover')) { setShowDropdown(false) } }, 200)}>
              <div className="dropdown-content">
                <div className="dropdown-item" onClick={handleCustomizeThemeClick}>
                  <FaCog size={27} className="dropdown-item-icon" />
                  <span>Customize Theme</span>
                </div>
                <div className="dropdown-item" onClick={() => { handleLogout(); setShowDropdown(false) }}>
                  <FaSignOutAlt size={20} className="dropdown-item-icon" />
                  <span>Logout</span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </nav>
  );
};
export default Breadcrumbs;